import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { Collapse } from "reactstrap";
import { backendService } from "../../services/backend.service";
import { messageService } from "../../services/message.service";
import "./menuAside.scss";

import IcoHome from "../../assets/imgs/iconos/ico_home.png";
import IcoProfile from "../../assets/imgs/iconos/ico_profile.png";
import IcoSchedule from "../../assets/imgs/iconos/ico_schedule.png";
import IcoPoll from "../../assets/imgs/iconos/ico_poll.png";
import IcoAgreements from "../../assets/imgs/iconos/ico_agreements.png";
import IcoJob from "../../assets/imgs/iconos/ico_job.png";
import IcoOurCompany from "../../assets/imgs/iconos/ico_ourCompany.png";
import IcoPoliticsProcess from "../../assets/imgs/iconos/ico_politicsprocess.png";
import IcoAyuda from "../../assets/imgs/iconos/ico_ayuda.png";
import IcoAdmin from "../../assets/imgs/iconos/ico_admin.png";
import IcoLearningCenter from "../../assets/imgs/iconos/ico_learning_center.png";
import IcoBoard from "../../assets/imgs/iconos/ico_board.png"
import { useSelector } from "react-redux";

export function OpenMenuAside({ activeMenu, closeAll }) {
  const roleName = useSelector((state) => state.userSettings.roleName);
  const [isOpen, setIsOpen] = useState(false);
  const toggleCollapse = () => setIsOpen(!isOpen);

  const MenuUsuario = () => {
    return (
      <div>
        <ul>
          <li>
            <NavLink className="menu_item" to="/home" onClick={closeAll}>
              <span className="ico_imgs">
                <img src={IcoHome} alt="Menu" />
              </span>
              <span>Muro</span>
            </NavLink>
          </li>
          <li>
            <NavLink className="menu_item" to="/profile" onClick={closeAll}>
              <span className="ico_imgs">
                <img src={IcoProfile} alt="Menu" />
              </span>
              <span>Mi Perfil</span>
            </NavLink>
          </li>
          <li>
            <NavLink className="menu_item" to="/diary" onClick={closeAll}>
              <span className="ico_imgs">
                <img src={IcoSchedule} alt="Menu" />
              </span>
              <span> Calendario </span>
            </NavLink>
          </li>
          <li>
            <NavLink
              className="menu_item"
              to={`/our-company/1`}
              onClick={closeAll}
            >
              <span className="ico_imgs">
                <img src={IcoOurCompany} alt="Menu" />
              </span>
              <span>Nuestra Empresa</span>
            </NavLink>
          </li>
          <li>
            <NavLink className="menu_item" to="/course-view" onClick={closeAll}>
              <span className="ico_imgs">
                <img src={IcoLearningCenter} alt="Menu" />
              </span>
              <span>
                 Learning Center{" "}
              </span>
            </NavLink>
          </li>
          <li>
            <NavLink className="menu_item" to="/policy-view" onClick={closeAll}>
              <span className="ico_imgs">
                <img src={IcoPoliticsProcess} alt="Menu" />
              </span>
              <span>
                 Políticas / Procesos{" "}
              </span>
            </NavLink>
          </li>
          <li>
            <NavLink className="menu_item" to="/audience" onClick={closeAll}>
              <span className="ico_imgs">
                <img src={IcoAgreements} alt="Menu" />
              </span>
              <span>Convenios</span>
            </NavLink>
          </li>
          <li>
            <NavLink className="menu_item" to="/board" onClick={closeAll}>
              <span className="ico_imgs">
                <img src={IcoBoard} alt="Menu" />
              </span>
              <span>Reconocimientos</span>
            </NavLink>
          </li>   
          <li>
            <NavLink className="menu_item" to="/bolsatrabajo" onClick={closeAll}>
              <span className="ico_imgs">
                <img src={IcoJob} alt="Menu" />
              </span>
              <span>Bolsa de Trabajo</span>
            </NavLink>
          </li>
          <li>
            <NavLink className="menu_item" to="/surveys" onClick={closeAll}>
              <span className="ico_imgs">
                <img src={IcoPoll} alt="Menu" />
              </span>
              <span>
                Encuestas
              </span>
            </NavLink>
          </li>
          <li>
            <NavLink className="menu_item" to="/help" onClick={closeAll}>
              <span className="ico_imgs">
                <img src={IcoAyuda} alt="Menu" />
              </span>
              <span>Ayuda</span>
            </NavLink>
          </li>
        </ul>
      </div>
    );
  };

  const MenuOperaciones = () => {
    return (
      <ul>
        <li>
          <div className="menu_item" onClick={toggleCollapse}>
            <span className="ico_imgs">
              <img src={IcoAdmin} alt="Menu" />
            </span>
            <span>
              Operaciones <i className="fas fa-caret-down"></i>
            </span>
          </div>
          <Collapse isOpen={isOpen}>
            <ul className="ul_collapse">
              <li>
                <NavLink
                  className="submenu_item"
                  to="/AdminCompany"
                  onClick={closeAll}
                >
                  Empresas
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="submenu_item"
                  to="/controlreward/1"
                  onClick={closeAll}
                >
                  Recompensas
                </NavLink>
              </li>
            </ul>
          </Collapse>
          <hr />
        </li>
      </ul>
    );
  };

  const MenuAdministrador = () => {
    return (
      <ul>
        <li>
          <div className="menu_item" onClick={toggleCollapse}>
            <span className="ico_imgs">
              <img src={IcoAdmin} alt="Menu" />
            </span>
            <span>
              Administrador <i className="fas fa-caret-down"></i>
            </span>
          </div>
          <Collapse isOpen={isOpen}>
            <ul className="ul_collapse">
              <li>
                <NavLink
                  className="submenu_item"
                  to="/admin-diary"
                  onClick={closeAll}
                >
                  Calendario
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="submenu_item"
                  to="/control"
                  onClick={closeAll}
                >
                  Control
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="submenu_item"
                  to="/course"
                  onClick={closeAll}
                >
                  Learning Center
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="submenu_item"
                  to="/AdminSurvey"
                  onClick={closeAll}
                >
                  Encuestas
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="submenu_item"
                  to="/CompanyPost"
                  onClick={closeAll}
                >
                  Nuestra Empresa
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="submenu_item"
                  to="/admin-audience"
                  onClick={closeAll}
                >
                  Convenios
                </NavLink>
              </li>
              <li>
                 <NavLink className="submenu_item" to="/AdminBoard" onClick={closeAll}>Reconocimientos</NavLink>
              </li>
              <li>
                <NavLink
                  className="submenu_item"
                  to="/users"
                  onClick={closeAll}
                >
                  Usuarios
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="submenu_item"
                  to="/admin-policy"
                  onClick={closeAll}
                >
                  Políticas / Procesos
                </NavLink>
              </li>
            </ul>
          </Collapse>
          <hr />
          <MenuUsuario />
        </li>
      </ul>
    );
  };

  return (
    <aside className={`wrapper_menu_aside ${activeMenu}`}>
      <nav className="nav_menu_items">
        {
          {
            Operaciones: <MenuOperaciones />,
            "Recursos Humanos": <MenuAdministrador />,
            Usuario: <MenuUsuario />,
            undefined: <MenuUsuario />,
          }[roleName]
        }
      </nav>
    </aside>
  );
}
